var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FeeRuleAddEdit',{attrs:{"status":_vm.$route.query.type,"id":_vm.$route.query.id,"billingWay":_vm.$route.query.billingWay},on:{"returnBack":_vm.goBack,"complete":_vm.saveOk}})}
var staticRenderFns = []

export { render, staticRenderFns }